import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllUserGroup() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllUserGroup`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllGroup() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCompanyUserGroups`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllGroupByAdmin() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllAdminGroups`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UserGroupDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getGroupById/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteUserGroup(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteUserGroup/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createUserGroup(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createUserGroup`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUserGroup(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateUserGroup/${drawerId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    UserGroupDetailData,
    FetchAllUserGroup,
    FetchAllGroup,
    FetchAllGroupByAdmin,
    deleteUserGroup,
    createUserGroup,
    updateUserGroup
}